import React from 'react';
import { Search } from 'lucide-react';
import EventCard from '@/components/layout/EventCard';
import { Input } from '@/components/ui/input';
import { Skeleton } from '@/components/ui/skeleton';
import { HomePageViewProps } from './homepage.props';

const HomePageView: React.FC<HomePageViewProps> = ({
  loading,
  searchQuery,
  setSearchQuery,
  filteredUpcoming,
  filteredPast,
}) => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Search Section */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="max-w-2xl mx-auto">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <Input
                type="text"
                placeholder="Пребарувај настани, локации, организатори..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-10 py-6 text-base"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Events Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {loading ? (
          <section className="mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Следни настани</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1, 2, 3].map((i) => (
                <div key={i} className="space-y-3">
                  <Skeleton className="h-48 w-full" />
                  <Skeleton className="h-4 w-3/4" />
                  <Skeleton className="h-4 w-1/2" />
                </div>
              ))}
            </div>
          </section>
        ) : (
          <>
            <section className="mb-16">
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Следни настани</h2>
              {filteredUpcoming.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {filteredUpcoming.map((event) => (
                    <EventCard key={event.id} event={event} />
                  ))}
                </div>
              ) : (
                <p className="text-gray-600 text-center py-12">Нема пронајдено настани.</p>
              )}
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Поминати настани</h2>
              {filteredPast.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {filteredPast.map((event) => (
                    <EventCard key={event.id} event={event} />
                  ))}
                </div>
              ) : (
                <p className="text-gray-600 text-center py-12">Нема пронајдено настани.</p>
              )}
            </section>
          </>
        )}
      </div>
    </div>
  );
};

export default HomePageView;
